// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1X4C0","alertIcon":"ConfirmModal_alertIcon__2Z8hc"};